/**
 *
 * Asynchronously loads the component for noAccessReducer
 *
 */
 import loadable from '../../utils/loadable';

 export default loadable(() => import('./index'));